import {ApiRes} from '../../../types/api'
import {API_URL, apiGet} from '../../api'
import {IBanners} from '../../banner/getLeaderboardBanner'
import {TypeSlot} from '../../promotion/create'

export interface ILandingPopup {
    promotion_set_id: string
    slot: TypeSlot
    banner?: IBanners
}
export const getLandingPopup = async (slot: TypeSlot): Promise<ApiRes<ILandingPopup[]>> => {
    return await apiGet(API_URL, `banners?slot=${slot}`)
}
